// Each step targets the section header <h2> containing the translated title.
// The ExplainerTour will find the closest .dashboard-section-dnd-wrapper as the highlight target.
// The profile selector step is only shown when the selector is actually rendered on the
// dashboard (hidden for pro users except hunters).
const DASHBOARD_STEPS = (t, { showProfileSelector = true } = {}) => {
  const steps = [];

  if (showProfileSelector) {
    steps.push({
      target: ".dashboard-display-mode-toggle",
      title: t("explainer.dashboard.step1.title", "Choisir son profil"),
      description: t("explainer.dashboard.step1.desc", "Sélectionnez votre profil pour personnaliser l'affichage du tableau de bord."),
    });
  }

  steps.push(
  {
    h2Text: t("dashboard.todo.title", "To do list"),
    title: t("explainer.dashboard.step2.title", "Votre ToDo Liste"),
    description: t("explainer.dashboard.step2.desc", "Retrouvez ici toutes les actions à réaliser pour avancer dans chaque étape de votre projet immobilier."),
  },
  {
    h2Text: t("dashboard.agentActivity.title", "Activité de vos assistants immobiliers IA"),
    title: t("explainer.dashboard.agentActivity.title", "Vos assistants immobiliers IA"),
    description: t("explainer.dashboard.agentActivity.desc", "Retrouvez les statistiques de l'activité de vos assistants immobiliers IA qui travaillent pour vous."),
  },
  {
    h2Text: t("dashboard.sections.training", "New content in the real estate training center"),
    title: t("explainer.dashboard.step3.title", "Learning Center"),
    description: t("explainer.dashboard.step3.desc", "Accédez aux derniers contenus pour vous aider à mieux gérer votre projet."),
  },
  {
    h2Text: t("dashboard.sections.propertyAttractivity", "Your property attractivity"),
    title: t("explainer.dashboard.step4.title", "Attractivité du bien"),
    description: t("explainer.dashboard.step4.desc", "Suivez l'évolution de l'attractivité de votre bien."),
  },
  {
    h2Text: t("dashboard.sections.ownerPipeline", "Seller or landlord pipeline overview"),
    title: t("explainer.dashboard.step5.title", "Synthèse transaction"),
    description: t("explainer.dashboard.step5.desc", "Vision synthétique de l'état de votre vente ou mise en location."),
  },
  {
    h2Text: t("dashboard.sections.p2pReport", "P2P Report"),
    title: t("explainer.dashboard.step6.title", "Baromètre prix - Synthèse"),
    description: t("explainer.dashboard.step6.desc", "Consultez la synthèse de vos campagnes Baromètre prix."),
  },
  {
    h2Text: t("dashboard.sections.pastTransactions", "Past transactions prices matching your last search criterion or property you own"),
    title: t("explainer.dashboard.step7.title", "Transactions récentes"),
    description: t("explainer.dashboard.step7.desc", "Illustrations de transactions récentes dans les zones qui vous intéressent."),
  },
  {
    h2Text: t("dashboard.sections.p2pEstimation", "P2P Estimation: help community members estimate their property"),
    title: t("explainer.dashboard.step8.title", "Baromètre prix - Avis"),
    description: t("explainer.dashboard.step8.desc", "Donnez votre avis sur les derniers biens du Baromètre prix."),
  },
  {
    h2Text: t("dashboard.sections.savedSearch", "Saved searches new results"),
    title: t("explainer.dashboard.step9.title", "Alertes résultats"),
    description: t("explainer.dashboard.step9.desc", "Activez des alertes et retrouvez ici les derniers biens correspondant à vos critères."),
  },
  {
    h2Text: t("dashboard.sections.followedPropertyNews", "Discover updates on the properties you follow"),
    title: t("explainer.dashboard.step10.title", "Biens suivis"),
    description: t("explainer.dashboard.step10.desc", "Actualités des biens que vous suivez pour anticiper votre projet immobilier."),
  },
  {
    h2Text: t("dashboard.sections.searchPipeline", "Property search pipeline overview"),
    title: t("explainer.dashboard.step11.title", "Pipeline recherche"),
    description: t("explainer.dashboard.step11.desc", "Vision synthétique de votre activité de recherche de bien sur AnyHomes."),
  },
  );

  return steps;
};

export default DASHBOARD_STEPS;
